export default __webpack_public_path__ + "static/media/XR3-img.2414256c.png";